import { request } from '../utils/apiHelper';
import { AppConfig } from '../types/app';
import { v4 as uuidv4 } from 'uuid';

/** Default path if the server config does not carry rememberLoginApiPath. */
const DEFAULT_REMEMBER_LOGIN_PATH = '/api/rememberLogin';

export type RememberLoginResult =
  | { action: 'redirect'; idp: string }
  | { action: 'none' };

// Asks /api/rememberLogin whether to redirect to the last-used IdP.
// Any failure resolves to { action: 'none' } so sign-in is never blocked.
export async function checkRememberLogin(
  config: AppConfig,
  clientId: string
): Promise<RememberLoginResult> {
  const path = config.rememberLoginApiPath || DEFAULT_REMEMBER_LOGIN_PATH;
  try {
    const response = await request(
      path,
      {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-Correlation-ID': uuidv4(),
        },
        body: JSON.stringify({ clientId }),
      },
      { metricNs: 'RememberLogin', logWithRum: true }
    );

    const data = await response.json();
    if (
      data?.action === 'redirect' &&
      typeof data.idp === 'string' &&
      data.idp
    ) {
      return { action: 'redirect', idp: data.idp };
    }
    return { action: 'none' };
  } catch {
    // Never block sign-in on a remember-login failure.
    return { action: 'none' };
  }
}

export default checkRememberLogin;
